import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Icon from '../../components/AppIcon';

import LoginForm from './components/LoginForm';
import SocialLogin from './components/SocialLogin';
import GuestCheckout from './components/GuestCheckout';
import SecurityBadges from './components/SecurityBadges';
import LoginHeader from './components/LoginHeader';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [showGuestOptions, setShowGuestOptions] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/home-page';
  const hasCartItems = JSON.parse(localStorage.getItem('cartItems') || '[]').length > 0;

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate(from, { replace: true });
    }

    setShowGuestOptions(hasCartItems);
  }, [navigate, from, hasCartItems]);

  const handleLogin = async (formData) => {
    setIsLoading(true);

    try {
      await new Promise(resolve => setTimeout(resolve, 1500));

      const userData = {
        id: 1,
        name: 'John Doe',
        email: formData.email,
        avatar: 'https://ui-avatars.com/api/?name=John+Doe&background=random',
        memberSince: '2023-01-15',
        orderCount: 12,
        wishlistCount: 8,
        rewardPoints: 1250
      };

      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userData', JSON.stringify(userData));
      if (formData.rememberMe) {
        localStorage.setItem('rememberMe', 'true');
      }

      window.dispatchEvent(new CustomEvent('authChanged', {
        detail: { isAuthenticated: true, user: userData }
      }));

      navigate(from, { replace: true });
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSocialLogin = async (userData) => {
    setIsLoading(true);

    try {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userData', JSON.stringify(userData));

      window.dispatchEvent(new CustomEvent('authChanged', {
        detail: { isAuthenticated: true, user: userData }
      }));

      navigate(from, { replace: true });
    } catch (error) {
      console.error('Social login failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-md mx-auto px-4 py-8">
        <LoginHeader />

        <div className="bg-surface border border-border rounded-lg shadow-card p-6 mb-6">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="User" size={32} className="text-primary" />
            </div>
            <h1 className="text-2xl font-semibold text-text-primary mb-2">
              {t('welcomeBack')}
            </h1>
            <p className="text-text-secondary">
              {t('signInMessage')}
            </p>
          </div>

          <LoginForm onSubmit={handleLogin} isLoading={isLoading} />

          <div className="mt-6">
            <SocialLogin onSocialLogin={handleSocialLogin} isLoading={isLoading} />
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-text-secondary">
              {t('noAccount')} <Link to="/register" className="text-primary hover:underline font-medium transition-smooth">{t('createOne')}</Link>
            </p>
          </div>
        </div>

      
      {/*  <div className="bg-surface border border-border rounded-lg shadow-card p-6">
          <SecurityBadges />
        </div>*/}

        <div className="mt-6 text-center space-y-2">
          <div className="flex items-center justify-center space-x-4 text-sm">
            <Link to="/home-page" className="text-text-secondary hover:text-primary transition-smooth">
              {t('continueShopping')}
            </Link>
            <span className="text-border">•</span>
            <Link to="/support" className="text-text-secondary hover:text-primary transition-smooth">
              {t('needHelp')}
            </Link>
          </div>
        </div>
      </div>

      {isLoading && (
        <div className="fixed inset-0 bg-black/20 flex items-center justify-center z-50">
          <div className="bg-surface rounded-lg p-6 shadow-interactive">
            <div className="flex items-center space-x-3">
              <div className="animate-spin rounded-full h-6 w-6 border-2 border-primary border-t-transparent"></div>
              <span className="text-text-primary">{t('signingIn')}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
